import { Button, Group, Modal, Text } from '@mantine/core'

interface ConfirmChangesModalProps {
  title: string
  description: string
  opened: boolean
  isLoading: boolean
  onClose: () => void
  onConfirm: () => void
  cancelLabel?: string
  confirmLabel?: string
  confirmColor?: string
}

export function ConfirmChangesModal({
  title,
  description,
  opened,
  isLoading,
  onClose,
  onConfirm,
  cancelLabel = 'Cancel',
  confirmLabel = 'Confirm Changes',
  confirmColor,
}: ConfirmChangesModalProps) {
  return (
    <Modal.Root opened={opened} onClose={onClose} centered>
      <Modal.Overlay />
      <Modal.Content>
        <Modal.Header>
          <Modal.Title>{title}</Modal.Title>
          <Modal.CloseButton />
        </Modal.Header>
        <Modal.Body>
          <Text size="sm">{description}</Text>
          <Group justify="flex-end" mt="xl">
            <Button variant="light" onClick={onClose}>
              {cancelLabel}
            </Button>
            <Button onClick={onConfirm} loading={isLoading} color={confirmColor}>
              {confirmLabel}
            </Button>
          </Group>
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  )
}
